import { CategoryKey } from './categories';

export const assets = [
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_eed3f66f58344b40a24a9ff6310d7329~mv2.png',
    productImageUrl: '',
  },
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_81d2cc0b7e544156a3f57efb951b57fe~mv2.png',
    productImageUrl: '',
  },
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_40bcdb1630e84053a99e578bb4504a50~mv2.png',
    productImageUrl: '',
  },
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_e6a1bd939a2847fab84f43c2c9b8cd83~mv2.png',
    productImageUrl: '',
  },
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_71d15ad1b63f466d9953718e00cd0eee~mv2.png',
    productImageUrl: '',
  },
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_5fc056586b744ef0baf7fe5d95555216~mv2.png',
    productImageUrl: '',
  },
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_19e2e0b3d3cb498c8a7fff7973235459~mv2.png',
    productImageUrl: '',
  },
  {
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_40f0833b50d64a1ba61079e92812e00f~mv2.png',
    productImageUrl: '',
  },
];

export const assetsByCategory: Record<CategoryKey, string[]> = {
  [CategoryKey.BestSellers]: [
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/36/36b39f22c52af2cd7c498ce39dae14e1_l',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/a7/a72cf6c22f67ffa678afbbaab0f5d3b3_l?v=b69e410724f23a521beaea098e4d43fc',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/b8/b891563d139c769430f9e1aece7886b3_l',
  ],
  [CategoryKey.MensClothing]: [
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/10/1074f1636b3fb830679c0872256755a3_l',
    'https://files.cdn.printful.com/o/upload/variant-image/25/2569c881f266557211dfc6f53e6536ad_l?v=81904077db9acd97b206c66eb444923d',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/43/43b38ff7584ef43c6d3315fc1b97765e_l',
  ],
  [CategoryKey.WomensClothing]: [
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/87/87d7a317d2fa1bec7cb9aad617e32fdf_l',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/e8/e8ae4dbe576e3c365c3f5f5a5d882764_l',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/de/de6984cac7da8780c510d86592cc0c0a_l',
  ],
  [CategoryKey.KidsClothing]: [
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/51/51dcd20a9edc588c4b6ab10913aa4e5d_l',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/91/915e06309f12c0ce27fe71b5f3916df4_l',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/06/060feff3de0c138d34936b193887e675_l',
  ],
  [CategoryKey.Hats]: [
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/ef/ef98a5288f8d3dd848334354a4c5ff69_l?v=dd4b3b9901c66d6a750e88710c688f4e',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/be/be689b7e4acc76912ddf794103bb5860_l?v=e2dbba558917a1cd0041107ff817e790',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/a8/a8f957473cdce9d10251265e72009f06_l',
  ],
  [CategoryKey.Accessories]: [
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/77/779b2a24791c635e0dec96a562f3d2ac_l',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/27/272ace98ecdd44c8c23ad9caaf469fa5_l',
    'https://files.cdn.printful.com/o/upload/variant-image-jpg/f4/f42925f7a7723988c3aed0cfc9ff43a4_l?v=b24f0db7be01901eb6d6d78699c826be',
  ],
};
